export default __webpack_public_path__ + "static/media/light.88085ce1.png";